import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import { SchemaRow } from "./schema.type";

export function getSchema(db: string) {
  try {
    const request = setHeaderOptions({
      method: "GET",
    });

    const url = `${ApiEndpoints.schema}/${db}`;

    return fetchData<SchemaRow[]>(url, request);
  } catch (error) {
    console.error("Error fetching schema:", error);
    throw error;
  }
}
